function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.3477 7.0529L23.5023 13.2075C23.8928 13.598 23.8928 14.2312 23.5023 14.6217L17.3477 20.7763C16.9571 21.1668 16.324 21.1668 15.9335 20.7763L9.77886 14.6217C9.38834 14.2312 9.38834 13.598 9.77886 13.2075L15.9335 7.0529C16.324 6.66238 16.9571 6.66238 17.3477 7.0529ZM18.7938 11.7961L16.6464 9.64871L12.3747 13.9146L14.5221 16.0619L18.7938 11.7961Z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.8311 21.8747C14.3754 21.7814 14.8923 22.147 14.9856 22.6914C15.0789 23.2357 14.7133 23.7526 14.1689 23.8459L13.8311 21.8747ZM4 14C4 18.3827 7.70212 22 12.35 22V24C6.67015 24 2 19.5585 2 14H4ZM12.35 6C7.70212 6 4 9.61734 4 14H2C2 8.44154 6.67015 4 12.35 4V6ZM12.35 22C12.8562 22 13.3511 21.9569 13.8311 21.8747L14.1689 23.8459C13.5777 23.9473 12.9698 24 12.35 24V22Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M15 5L11 1V9L15 5Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11 1H10.5C10.5 0.797769 10.6218 0.615451 10.8087 0.53806C10.9955 0.46067 11.2106 0.503448 11.3536 0.646447L11 1ZM15 5L15.3536 4.64645C15.5488 4.84171 15.5488 5.15829 15.3536 5.35355L15 5ZM11 9L11.3536 9.35355C11.2106 9.49655 10.9955 9.53933 10.8087 9.46194C10.6218 9.38455 10.5 9.20223 10.5 9H11ZM11.3536 0.646447L15.3536 4.64645L14.6464 5.35355L10.6464 1.35355L11.3536 0.646447ZM15.3536 5.35355L11.3536 9.35355L10.6464 8.64645L14.6464 4.64645L15.3536 5.35355ZM10.5 9V1H11.5V9H10.5Z"
});

function SvgSwitchOrientationReverse(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather feather-switch-orientation-reverse",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchOrientationReverse);
export default __webpack_public_path__ + "static/media/switch-orientation-reverse.b3e9291c.svg";
export { ForwardRef as ReactComponent };